import { MouseEventHandler } from 'react';

import classes from './FullscreenButton.module.css';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const FullscreenButton: React.FC<Props> = ({ onClick }) => {
  return (
    <button
      style={{ zIndex: '10000' }}
      className={classes['fullscreen-btn']}
      id="js-fullscreen-btn"
      onClick={onClick}
    >
      <span className={classes['fullscreen-icon']} title="Full Screen" />
    </button>
  );
};

export default FullscreenButton;
